import React from "react";
import { IoCheckmarkCircle, IoCardOutline, IoDownloadOutline } from "react-icons/io5";

export default function HistoryCard({
  id,
  tarih,
  yontem,
  tutar,
  durum,
  onDownload,
}) {
  const isPartial = durum === "Kısmi Ödeme";

  return (
    <div className="bg-white rounded-2xl p-4 border border-gray-100 shadow-[0px_2px_8px_rgba(0,0,0,0.02)] flex flex-col justify-between">
      <div className="flex justify-between items-start">
        <div className="flex items-start gap-3">
          <div
            className={`w-10 h-10 rounded-full flex items-center justify-center text-xl flex-shrink-0 mt-0.5 ${isPartial ? "bg-amber-50 text-amber-600" : "bg-green-50 text-green-600"
              }`}
          >
            {isPartial ? <IoCardOutline /> : <IoCheckmarkCircle />}
          </div>

          <div>
            <h4 className="text-gray-900 text-lg font-semibold">{id || "-"}. Taksit</h4>
            <p className="text-gray-500 text-sm mt-0.5">{tarih || "-"}</p>
            <p className="text-gray-500 text-sm mt-0.5">{yontem || "-"}</p>
          </div>
        </div>

        <div className="text-right">
          <p className="text-lg font-bold text-gray-900">{tutar || "₺0,00"}</p>
          <span
            className={`inline-block text-xs font-bold px-2.5 py-0.5 rounded-full border mt-1.5 tracking-wide ${isPartial
              ? "bg-amber-50 text-amber-700 border-amber-200"
              : "bg-green-50 text-green-600 border-green-100"
              }`}
          >
            {durum || "Ödendi"}
          </span>
        </div>
      </div>

      <div className="border-t border-gray-100 my-3.5"></div>

      <button
        onClick={onDownload}
        className="w-full font-semibold flex items-center justify-center gap-1.5 text-blue-600 hover:text-blue-700 transition-colors py-1 cursor-pointer"
      >
        <IoDownloadOutline className="text-lg" />
        Makbuzu Görüntüle
      </button>
    </div>
  );
}

